/**
 * Progress toward the next ticket on a goal that repeats every `interval`.
 *
 * The earning rules themselves live in config/campaign.js. This file is only the
 * arithmetic over them: the old dashboard showed a raw count and never told
 * anyone what to do next, which is the whole point of a loyalty page.
 *
 * @returns {{earned: number, progress: number, nextHint: string}}
 */
export const describeRepeatingGoal = ({count, interval, pointsPerInterval, unit, action}) => {
    const completed = Math.floor(count / interval);
    const towardNext = count % interval;

    return {
        earned: completed * pointsPerInterval,
        progress: towardNext / interval,
        nextHint: `Дахин ${interval - towardNext} ${unit} ${action} +${pointsPerInterval} эрх нэмэгдэнэ`,
    };
};
